import { useEffect } from 'react';
import { Card, Col, Grid, Image, Row, Typography } from 'antd';
import CardC from 'src/components/Card';
import FormContact from '../Forms/Contact';
import classes from './index.module.less';
const ContactContainer = () => {
  const {
    xs
  } = Grid.useBreakpoint();
  useEffect(() => {
    window.scrollBy({
      top: 5,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  return <div className={classes['container-page']}>
			<div className={classes.headContact}>
				<h1 className={classes.title}>Hubungi Kami</h1>
				<Typography className={classes.paragraph}>
					Kirim Pertanyaan, masukan, maupun saran sehingga mama lebih nyaman
				</Typography>
			</div>
			<div className="container" style={{
      paddingBottom: '30px'
    }}>
				<CardC>
					<Row gutter={[16, 16]}>
						<Col xs={{
            span: 24,
            order: 2
          }} sm={{
            span: 10,
            order: 1
          }} md={10} lg={10} xl={10} xxl={10}>
							<Card hoverable={false} style={{
              border: 'none'
            }} cover={<Image alt="contact" src="/images/default/frame-contact-us.svg" preview={false} />}>
								<div className={classes.content}>
									<h2 className={classes.t}>Kontak Kami</h2>
									<h3 className={classes.p1}>Mama juga bisa menghubungi kami melalui</h3>

									<Row>
										<Col md={3} sm={3} xs={3}>
											<a href="mailto:cs@hallobumil.com?subject=Min Aku Mau Tanya : " target="_blank" rel="noreferrer">
												{' '}
												<Image src="/images/default/contact-email.png"
                      // style={{ weight: '50', height: 50 }}
                      alt="contactemail" preview={false} />
											</a>
										</Col>
										<Col>
											<a href="https://mail.google.com/mail/?view=cm&fs=1&to=cs@hallobumil.com&su=Hello Min, Mama Mau Tanya :" target="_blank" rel="noreferrer">
												<p className={classes.p}>cs@hallobumil.com</p>
											</a>
										</Col>
									</Row>
									<Row>
										<Col md={3} sm={3} xs={3}>
											<a href="https://api.whatsapp.com/send/?phone=6285134954019&text&type=phone_number&app_absent=0" target="_blank" rel="noreferrer">
												<Image src="/images/default/contact-phone.png"
                      // style={{ weight: '50', height: 50 }}
                      alt="contactphone" preview={false} />
											</a>
										</Col>
										<Col>
											<a href="https://api.whatsapp.com/send/?phone=6285134954019&text&type=phone_number&app_absent=0" target="_blank" rel="noreferrer">
												<p className={classes.p}>+6285134954019</p>
											</a>
										</Col>
									</Row>
								</div>
							</Card>
						</Col>
						<Col xs={{
            span: 24,
            order: 1
          }} sm={{
            span: 14,
            order: 2
          }} md={14} lg={14} xl={14} xxl={14}>
							<div style={{
              marginLeft: xs ? '0px' : '44px'
            }}>
								<FormContact />
							</div>
						</Col>
					</Row>
				</CardC>
				{/* <Col lg={14} md={24} sm={24} xs={24}>
     	<div className={classes['image-content']}>
     		<ImageC
     			alt="Icon Tenaga Kesehatan"
     			src="/images/mitra_korporasi/mitra-korporasi.svg"
     			objectFit="cover"
     			layout="responsive"
     		/>
     	</div>
     </Col> */}
				{/* </div> */}
			</div>
		</div>;
};
export default ContactContainer;